import React from "react";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import { Typography } from "@mui/material";

import FormControlLabel from "@mui/material/FormControlLabel";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

const Generalsetting = () => {
  return (
    <>
      <div className="boDy">
        {" "}
        <div className="mt-3">
          <h2>Settings</h2>
        </div>
        <div className="box">
          <div className="border-bottom">
            <div className="container">
              <h5>Website Setting</h5>
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <h6>Company Name</h6>
                <TextField
                  type="text"
                  name="name"
                  label="VMS*"
                  sx={{ height: "48px", width: "100%" }}
                />
              </div>
              <div className="col-md-4">
                <h6>Address</h6>
                <TextField
                  label="19/14 first street,karachi pakistan"
                  type="name"
                  name="address"
                  sx={{ height: "48px", width: "100%" }}
                />{" "}
              </div>
              <div className="col-md-4">
                <h6>Googel API Key</h6>
                <TextField
                  sx={{ height: "48px", width: "100%" }}
                  type="text"
                  name="name"
                  label="AIzaSyDapMdqmN4EL6aOWgh1n6TDy3xenT8eM_s*"
                />
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <h6>Invoice Prefix</h6>
                <TextField
                  type="text"
                  name="name"
                  label="TEST*"
                  sx={{ height: "48px", width: "100%" }}
                />
              </div>
              <div className="col-md-4">
                <h6>Currency Prefix</h6>
                <TextField
                  label="$"
                  type="email"
                  name="email"
                  sx={{ height: "48px", width: "100%" }}
                />{" "}
              </div>
              <div className="col-md-4">
                <h6>Inovice Service Name</h6>
                <TextField
                  sx={{ height: "48px", width: "100%" }}
                  type="text"
                  name="name"
                  label="Vehicle Booking*"
                />
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <h6>Inovice Terms and condition</h6>
                <TextField
                  sx={{ height: "100px", width: "100%" }}
                  id="outlined-textarea"
                  label="Sample invoice terms and condition..Please change it in settings page............ "
                  multiline
                />
              </div>
              <div className="col-md-4">
                <h6>Logo</h6>
                <Button
                  variant="outlined"
                  component="label"
                  style={{ marginTop: "8px" }}
                >
                  Choose File
                  <input type="file" hidden id="manufactured-by-file" />
                </Button>
              </div>
              <div className="col-md-4">
                <h6>Date Format</h6>
                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      sx={{ height: "48px", width: "100%", color: "#222" }}
                    >
                      <MenuItem value="Car">Car</MenuItem>
                      <MenuItem value="motorcyle">MOTORCYLE</MenuItem>
                      <MenuItem value="truck">TRUCK</MenuItem>
                      <MenuItem value="bus">Bus</MenuItem>
                      <MenuItem value="taxi">Taxi</MenuItem>
                      <MenuItem value="bicyle">Bicyle</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </div>
            </div>
          </div>
          <div className="mt-4 aDD">
            <button>Submit</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Generalsetting;
